import Client from "common/api/Client";
import config from "src/config";
import authClient from "common/auth/client";
import { isTokenExpired } from "common/auth/token";

class AdminClient extends Client {
  constructor() {
    super({ apiPath: config.api.admin });
  }

  _wrappedRequest(...args) {
    return this.request(...args).catch((err) => {
      if (isTokenExpired(err)) {
        return authClient.refreshAccessToken().then(() => {
          return this.request(...args);
        });
      } else {
        throw err;
      }
    });
  }

  get(url, options = {}) {
    return this._wrappedRequest(url, Object.assign({ method: "GET" }, options));
  }

  patch(url, options = {}) {
    return this._wrappedRequest(
      url,
      Object.assign({ method: "PATCH" }, options)
    );
  }

  post(url, options = {}) {
    return this._wrappedRequest(
      url,
      Object.assign({ method: "POST" }, options)
    );
  }

  del(url, options = {}) {
    return this._wrappedRequest(
      url,
      Object.assign({ method: "DELETE" }, options)
    );
  }

  postFile(resource, id, name, file) {
    const formData = new window.FormData();
    formData.append("file", file, file.name);

    return this._wrappedRequest(`files/${resource}/${id}/${name}`, {
      method: "POST",
      body: formData,
    });
  }
}

export default new AdminClient();
